<template>
    <a-select class="select"
              :allowClear="true"
              :show-search="true"
              :value="selectValue"
              @change="onchange" >
        <a-select-option v-for="item in dataList"
                         :key="getKey(item)">
            {{item.name}}
        </a-select-option>
    </a-select>
</template>

<script>
    export default {
        props:{
            selectValue:{
                type:String,
                default:''
            },
            dataList:{
                type:Array,
                default(){
                    return []
                }
            }
        },
        methods:{
            getKey(item){
                if(item.value){
                    return item.value
                }else{
                    return item.id
                }
            },
            onchange(value){
                this.$emit('update:selectValue',value);
                this.$emit('change',value)
            }
        },

    }
</script>

<style scoped>
.select{
    width: 100%;
}
</style>
